import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import VideoBox from "../../../components/common/videoBox";
import CarouselComponent from "../../../components/common/carouselVideos";

const useStyles = makeStyles((theme) => ({
  videoSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    overflow: "visible",
    [theme.breakpoints.up("md")]: {},
  },
  videoSectionBoxes: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
      alignItems: "center",
      width: "100%",
      margin: "0 auto",
    },
    [theme.breakpoints.down("md")]: {
      gap: 40,
      justifyContent: "center",
    },
  },
  boldSpan: {
    fontWeight: 600
  },
  appInfosTitle: {
    textAlign: 'start',
    fontSize: 24,
    [theme.breakpoints.up("md")]: {
      fontSize: 40,
    },
    color: "#4E5258",
    fontFamily: "Nunito",
    [theme.breakpoints.up("xs")]: {
      marginBottom: theme.spacing(5),
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: theme.spacing(0)
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: 'center',
    },
  },
  appInfosBoxes: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "none",
    overflow: "visible",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
}));

const ProfessionalsVideoSection = ({ InfoVideosData }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Grid container className={classes.videoSection}>
      <Typography
        variant="h2"
        className={`${classes.appInfosTitle} ${classes.purple}`}
        data-aos={isMobile ? "" : "fade-up"}
        data-aos-duration="800"
      >
        Feito para profissionais que trabalham com <span className={classes.boldSpan}>hora marcada</span>
      </Typography>
      {isMobile ? (
        <Grid container className={classes.appInfosBoxes}>
          <CarouselComponent carouselData={InfoVideosData} />
        </Grid>
      ) : (
        <Grid container className={classes.videoSectionBoxes}>
          {InfoVideosData.map((data) => (
            <VideoBox
              key={data.key}
              background={data.background}
              text={data.text}
              url={data.url}
            />
          ))}
        </Grid>
      )}
    </Grid>
  );
};

export default ProfessionalsVideoSection;
